module.exports = __webpack_public_path__ + "Roboto-Light.a990f611f2305dc12965.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Light.eot
// module id = 86
// module chunks = 2